// Media Gallery Popup functionality
class MediaGalleryPopup {
  constructor() {
    this.popup = document.getElementById('media-gallery-popup');
    this.popupCloseBtn = document.querySelector('.media-gallery-popup-close');
    this.mainGallery = document.querySelector('media-gallery');
    this.popupGallery = document.querySelector('media-gallery-popup');
    this.mainViewerItems = document.querySelectorAll('.media-gallery:not(.media-gallery--popup) .media-viewer__item');
    this.popupViewerItems = document.querySelectorAll('.media-gallery--popup .media-viewer__item');
    this.popupViewerList = document.getElementById('gallery-viewer-popup');
    this.popupThumbsItems = document.querySelectorAll('.media-gallery--popup .media-thumbs__item');
    this.popupPrevBtn = document.querySelector('.media-gallery--popup .media-ctrl__btn[name="prev"]');
    this.popupNextBtn = document.querySelector('.media-gallery--popup .media-ctrl__btn[name="next"]');
    this.popupCurrentCounter = document.querySelector('.media-gallery--popup .media-ctrl__current-item');
    this.loadingSpinner = document.querySelector('.media-gallery--popup .loading-spinner');
    this.zoomLinks = this.popupGallery.querySelectorAll('.js-zoom-link');
    this.currentIndex = 0;
    this.isDesktop = window.innerWidth > 768;

    this.init();
  }

  init() {
    // Only enable popup on desktop
    if (!this.isDesktop) return;

    // Add click handlers to main gallery items
    this.mainViewerItems.forEach((item, index) => {
      item.addEventListener('click', () => this.openPopup(index));
    });

    // Add close button handler
    if (this.popupCloseBtn) {
      this.popupCloseBtn.addEventListener('click', () => this.closePopup());
    }

    // Close popup when clicking on overlay
    if (this.popup) {
      this.popup.addEventListener('click', (e) => {
        if (e.target === this.popup) {
          this.closePopup();
        }
      });
    }

    // Navigation buttons
    if (this.popupPrevBtn) {
      this.popupPrevBtn.addEventListener('click', () => this.previousImage());
    }

    if (this.popupNextBtn) {
      this.popupNextBtn.addEventListener('click', () => this.nextImage());
    }

    // Thumbnail navigation
    this.popupThumbsItems.forEach((item, index) => {
      const btn = item.querySelector('.media-thumbs__btn');
      if (btn) {
        btn.addEventListener('click', () => this.goToImage(index));
      }
    });

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (!this.popup.classList.contains('is-active')) return;

      if (e.key === 'Escape') {
        this.closePopup();
      } else if (e.key === 'ArrowLeft') {
        this.previousImage();
      } else if (e.key === 'ArrowRight') {
        this.nextImage();
      }
    });

    // Zoom initialization
    if (this.zoomLinks.length > 0) {
      this.zoomInitHandler = this.zoomInitHandler || this.initZoom.bind(this);
      this.zoomEventListener = this.zoomEventListener || this.handleZoomMouseMove.bind(this);
      window.addEventListener('on:debounced-resize', this.zoomInitHandler);
    }

    // Handle window resize
    window.addEventListener('resize', () => {
      this.isDesktop = window.innerWidth > 768;
      if (!this.isDesktop && this.popup.classList.contains('is-active')) {
        this.closePopup();
      }
    });
  }

  openPopup(index) {
    if (!this.isDesktop) return;

    this.currentIndex = index;
    this.popup.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    this.updatePopupGallery();

    // Initialize zoom for the popup
    if (this.zoomLinks.length > 0) {
      setTimeout(() => {
        this.initZoom();
      }, 100);
    }
  }

  closePopup() {
    this.popup.classList.remove('is-active');
    document.body.style.overflow = '';
    
    // Remove zoom event listeners
    if (this.zoomLinks.length > 0 && this.zoomEventListener) {
      this.zoomLinks.forEach((el) => {
        el.removeEventListener('mousemove', this.zoomEventListener);
      });
    }
    
    window.pauseAllMedia();
  }

  goToImage(index) {
    this.currentIndex = index;
    this.updatePopupGallery();
  }

  previousImage() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      window.pauseAllMedia();
      this.updatePopupGallery();
    }
  }

  nextImage() {
    if (this.currentIndex < this.popupViewerItems.length - 1) {
      this.currentIndex++;
      window.pauseAllMedia();
      this.updatePopupGallery();
    }
  }

  updatePopupGallery() {
    // Update active classes on viewer items
    this.popupViewerItems.forEach((item, index) => {
      if (index === this.currentIndex) {
        item.classList.add('is-active');
      } else {
        item.classList.remove('is-active');
      }
    });

    // Scroll the viewer to show current item using transform
    if (this.popupViewerList) {
      const scrollPosition = -(this.currentIndex * 100) - 50;
      this.popupViewerList.style.transform = `translateX(${scrollPosition}%)`;
    }

    // Update active classes on thumbnail items
    this.popupThumbsItems.forEach((item, index) => {
      const btn = item.querySelector('.media-thumbs__btn');
      if (index === this.currentIndex) {
        item.classList.add('is-active');
        if (btn) {
          btn.classList.add('is-active');
          btn.setAttribute('aria-current', 'true');
        }
        // Scroll thumbnail into view
        item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      } else {
        item.classList.remove('is-active');
        if (btn) {
          btn.classList.remove('is-active');
          btn.removeAttribute('aria-current');
        }
      }
    });

    // Update counter
    if (this.popupCurrentCounter) {
      this.popupCurrentCounter.textContent = this.currentIndex + 1;
    }

    // Update button disabled states
    if (this.popupPrevBtn) {
      this.popupPrevBtn.disabled = this.currentIndex === 0;
    }

    if (this.popupNextBtn) {
      this.popupNextBtn.disabled = this.currentIndex === this.popupViewerItems.length - 1;
    }

    // Re-initialize zoom for active item
    if (this.zoomLinks.length > 0) {
      this.initZoom();
    }
  }

  /**
   * Initialized the zoom on hover for popup gallery
   */
  initZoom() {
    this.zoomLinks.forEach((el) => {

        el.addEventListener('click', (e) => {
          e.preventDefault();
        });

        const zoomImage = el.querySelector('.zoom-image');
        if (!zoomImage) return;

        const zoomWidth = Number(zoomImage.dataset.originalWidth || 0);
        const productImage = el.querySelector('.product-image');
        if (!productImage) return;

        const imageWidth = productImage.getBoundingClientRect().width;
        if (theme.mediaMatches && theme.mediaMatches.md && ((zoomWidth - 75) > (imageWidth))) {
            el.addEventListener('mousemove', this.zoomEventListener);
            el.classList.remove('pointer-events-none');
        } else {
            el.removeEventListener('mousemove', this.zoomEventListener);
            el.classList.add('pointer-events-none');
        }
    });
  }

  /**
   * Handles mouse move over a zoomable image in popup
   * @param {?object} evt - Event object.
   */
  handleZoomMouseMove(evt) {
    const hoverElem = evt.currentTarget;
    const zoomImage = hoverElem.querySelector('.js-zoom-image');

    if (!zoomImage) return;

    // Download the zoom image if necessary
    if (zoomImage.dataset.src) {
      if (this.loadingSpinner) {
        this.loadingSpinner.classList.remove('loading-spinner--out');
      }

      const img = new Image();
      img.src = zoomImage.dataset.src;
      img.onload = () => {
        zoomImage.src = img.src;
        hoverElem.classList.remove('media--zoom-not-loaded');
        if (this.loadingSpinner) {
          this.loadingSpinner.classList.add('loading-spinner--out');
        }
      };
      zoomImage.removeAttribute('data-src');
    }

    try {
      const offsetX = evt.offsetX ? evt.offsetX : evt.touches[0].pageX;
      const offsetY = evt.offsetY ? evt.offsetY : evt.touches[0].pageY;
      const x = (offsetX / zoomImage.offsetWidth) * 100;
      const y = (offsetY / zoomImage.offsetHeight) * 100;
      zoomImage.style.objectPosition = `${x}% ${y}%`;
    } catch (err) {
      // Fail silently
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new MediaGalleryPopup();
  });
} else {
  new MediaGalleryPopup();
}
